import { createReduxStore, register } from '@wordpress/data';

const { flowEW } = window;

export const STORE_NAME = 'flow-ew/review';

const DEFAULT_STATE = {
  reviewers: [],
  review: flowEW.activeReview || null,
  loading: false,
  error: null,
};

const flowStore = createReduxStore(STORE_NAME, {
  reducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
      case 'SET_REVIEWERS':
        return { ...state, reviewers: action.reviewers };
      case 'SET_REVIEW':
        return { ...state, review: action.review };
      case 'SET_LOADING':
        return { ...state, loading: action.loading };
      case 'SET_ERROR':
        return { ...state, error: action.error };
      default:
        return state;
    }
  },
  actions: {
    setReviewers: (reviewers) => ({ type: 'SET_REVIEWERS', reviewers }),
    setReview: (review) => ({ type: 'SET_REVIEW', review }),
    setLoading: (loading) => ({ type: 'SET_LOADING', loading }),
    setError: (error) => ({ type: 'SET_ERROR', error }),
  },
  selectors: {
    getReviewers: (state) => state.reviewers,
    getReview: (state) => state.review,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },
});

register(flowStore);

export const STATUS_LABELS = {
  pending: flowEW.i18n.statusPending,
  in_review: flowEW.i18n.statusInReview,
  changes_requested: flowEW.i18n.statusChangesReq,
  approved: flowEW.i18n.statusApproved,
  open_review: flowEW.i18n.statusOpenReview,
};

export const STATUS_COLORS = {
  pending: '#757575',
  in_review: '#996800',
  changes_requested: '#8a2424',
  approved: '#1a6b28',
  open_review: '#0a4f9e',
};
